module.exports = global["React"] = require("-!./react.js");


//////////////////
// WEBPACK FOOTER
// ./~/react/react.js-exposed
// module id = 172
// module chunks = 0